module.exports = __webpack_public_path__ + "img/logo-gilead.4bbaa447.png";